import Chat from './Svg/Chat';
import styles from 'styles/modules/EmptyBlock.module.scss';
import Typo from './Typo';
import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth';

// Empty-state copy is an instruction to the owner, not a fact about the member,
// and Google was lifting "No media coverage has been added yet" into the
// snippet for profiles with nothing to show. Gated here rather than in each
// caller so coverage, stories and alerts all stay out of the crawlable HTML.
const EmptyBlock = ({ title }) => {
    const { isAuthorized } = useSelector(authSelector);

    if (!isAuthorized) {
        return null;
    }

    return (
        <>
            <div className={styles.block}>
                <Typo variant={'h3'} className={styles.title}>
                    <Chat />
                    {title}
                </Typo>
            </div>
        </>
    );
};

export default EmptyBlock;
